import React, { useState } from "react";
import SettingsPage from "./TabPages/SettingsPage";
import ReviewQueuePage from "./TabPages/ReviewQueuePage";
import BulkActionsPage from "./TabPages/BulkActionsPage";
import ReportsPage from "./TabPages/ReportsPage";
// icons ------------------------------------------------
import { IoSettings } from "react-icons/io5";
import { IoIosPlay } from "react-icons/io";

const TDSModuleLayout = () => {
    const [activeMenu, setActiveMenu] = useState(1);

    // ✅ Config-driven structure: easy to scale
    const pages = [
        { id: 1, label: "Review Queue", component: <ReviewQueuePage /> },
        { id: 2, label: "Bulk Actions", component: <BulkActionsPage /> },
        { id: 3, label: "Reports", component: <ReportsPage /> },
        { id: 4, label: "Settings", component: <SettingsPage /> },
    ];

    // find active page based on menu id
    const activePage = pages.find((p) => p.id === activeMenu)?.component || <SettingsPage />;

    return (
        <div className="min-h-screen">
            {/* Top Navbar */}
            <div className="tds-tab">
                <div className="flex items-center gap-2 font-20 font-semibold color-white">
                    <IoSettings className="tds-seeting-icon"/> &nbsp;
                    <span>TDS Module</span>
                </div>

                <IoIosPlay className="font-12 color-white"/>

                <div className="tds-tab-items">
                    {pages.map((item) => (
                        <button
                            key={item.id}
                            onClick={() => setActiveMenu(item.id)}
                            className={`text-sm ${activeMenu === item.id
                                    ? "tds-tab-item active"
                                    : "tds-tab-item"
                                }`}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Page Content */}
            <div className="p-20-30">{activePage}</div>
        </div>
    );
};

export default TDSModuleLayout;
